export const entityCustomTypeOptionId = 'customEntityType';

export const entityTypePresets = [
  {
    id: 'agent',
    icon: 'tabler:headset',
    typeLabels: { en: 'Agent', he: 'סוכן' },
    nameSuggestions: { en: 'Agent', he: 'סוכן' }
  },
  {
    id: 'team',
    icon: 'tabler:users-group',
    typeLabels: { en: 'Team', he: 'צוות' },
    nameSuggestions: { en: 'Team', he: 'צוות' }
  },
  {
    id: 'department',
    icon: 'tabler:building',
    typeLabels: { en: 'Department', he: 'מחלקה' },
    nameSuggestions: { en: 'Department', he: 'מחלקה' }
  },
  {
    id: 'supervisor',
    icon: 'tabler:user-star',
    typeLabels: { en: 'Supervisor', he: 'מנהל' },
    nameSuggestions: { en: 'Supervisor', he: 'מנהל' }
  },
  {
    id: 'customer',
    icon: 'tabler:user',
    typeLabels: { en: 'Customer', he: 'לקוח' },
    nameSuggestions: { en: 'Customer', he: 'לקוח' }
  },
  {
    id: 'bot',
    icon: 'tabler:robot',
    typeLabels: { en: 'Bot', he: 'בוט' },
    nameSuggestions: { en: 'Bot', he: 'בוט' }
  }
];

export const entityIconPresets = [
  { id: 'tabler:headset', labelKey: 'headset' },
  { id: 'tabler:users-group', labelKey: 'usersGroup' },
  { id: 'tabler:building', labelKey: 'building' },
  { id: 'tabler:user-star', labelKey: 'userStar' },
  { id: 'tabler:user', labelKey: 'user' },
  { id: 'tabler:robot', labelKey: 'robot' },
  { id: 'tabler:users', labelKey: 'users' },
  { id: 'tabler:briefcase', labelKey: 'briefcase' },
  { id: 'tabler:phone', labelKey: 'phone' },
  { id: 'tabler:message', labelKey: 'message' },
  { id: 'tabler:world', labelKey: 'world' },
  { id: 'tabler:shield', labelKey: 'shield' }
];

export function isEntityCustomTypeOptionId(entityTypeOptionId) {
  const normalizedEntityTypeOptionId = typeof entityTypeOptionId === 'string' ? entityTypeOptionId.trim() : '';
  if (normalizedEntityTypeOptionId === '') {
    return false;
  }
  if (normalizedEntityTypeOptionId === entityCustomTypeOptionId) {
    return true;
  }
  return false;
}

export function findEntityTypePreset(entityTypeId) {
  const normalizedEntityTypeId = typeof entityTypeId === 'string' ? entityTypeId.trim().toLowerCase() : '';
  if (normalizedEntityTypeId === '') {
    return null;
  }
  for (let entityTypePresetIndex = 0; entityTypePresetIndex < entityTypePresets.length; entityTypePresetIndex = entityTypePresetIndex + 1) {
    if (entityTypePresets[entityTypePresetIndex].id === normalizedEntityTypeId) {
      return entityTypePresets[entityTypePresetIndex];
    }
  }
  return null;
}

export function normalizeEntityTypeKey(entityTypeValue) {
  if (typeof entityTypeValue !== 'string') {
    return '';
  }
  return entityTypeValue.trim().toLowerCase().replace(/[^a-z0-9_-]/g, '').substring(0, 80);
}

export function resolveEntityIconValue(entityIconValue) {
  const normalizedEntityIcon = typeof entityIconValue === 'string' ? entityIconValue.trim() : '';
  if (normalizedEntityIcon === '') {
    return 'tabler:user';
  }
  if (normalizedEntityIcon.indexOf(':') > -1) {
    return normalizedEntityIcon;
  }
  return `tabler:${normalizedEntityIcon}`;
}
